<igx-linear-bar
  type="default"
  [value]="100"
  class="indeterminate"
  [indeterminate]="true"
></igx-linear-bar>
